import { Country } from '@commenda/prisma';
import { TComplianceItem } from '@commenda/types/src/compliance-calendar/compliances/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export default function useCAFirmCompliances(
  token: string,
  caFirmId: string,
  filter?: { corporationIds: number[] }
) {
  const query = new URLSearchParams();
  if (filter?.corporationIds) {
    query.append('corporationIds', filter.corporationIds.join(','));
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: {
      compliances: (TComplianceItem & {
        corporation: {
          id: number;
          companyLegalName: string;
          incorporationCountry: Country;
          isBookkeepingEnabled?: boolean;
          isSalesTaxEnabled?: boolean;
        };
        company: { id: number; companyDisplayName: string };
      })[];
    };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `caFirm/${caFirmId}/allCompliances?${query}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
